import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { GLOBAL_NAVIGATION_SIDEBAR_WIDTH, GLOBAL_NAVIGATION_TOOLBAR_HEIGHT } from 'nav-meta/constants';
import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import { GRID_BREAKPOINT_SMALL } from '../../layout/constants';
import { useStorefrontHeaderBackgroundStyles } from '../../storefront/components/StorefrontHeader.utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSearchSelectWrapper = styled.div.withConfig({
  displayName: "SearchSelectWrapper__StyledSearchSelectWrapper",
  componentId: "sc-1r65hc9-0"
})(({
  $collapsed: collapsed,
  $color: color,
  $cssStyles: cssStyles,
  $gradientAngle: gradientAngle,
  $isSticky: isSticky,
  $isNewAppNav: isNewAppNav,
  $stickyTopOffset: stickyTopOffset
}) => {
  const theme = useTheme();
  const storefrontHeaderBackgroundStyles = useStorefrontHeaderBackgroundStyles({
    color,
    gradientAngle
  });
  const backgroundStyles = collapsed || isSticky ? storefrontHeaderBackgroundStyles : {
    backgroundImage: 'none'
  };
  return Object.assign({}, cssStyles, backgroundStyles, {
    // Prop-based styling for sticky state
    zIndex: isSticky ? '1111' : 'auto',
    position: isSticky ? 'fixed' : 'static',
    top: isSticky ? `${stickyTopOffset !== null && stickyTopOffset !== void 0 ? stickyTopOffset : 0}px` : 'auto',
    right: isSticky ? '0' : 'auto',
    // Handle width for new app nav when sticky
    width: isSticky ? isNewAppNav ? `calc(100% - var(--global-nav-vertical-nav-width, ${GLOBAL_NAVIGATION_SIDEBAR_WIDTH}))` : '100%' : 'auto',
    // Prop-based styling for collapsed state
    minHeight: isSticky ? GLOBAL_NAVIGATION_TOOLBAR_HEIGHT : 'auto',
    [`@media screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: {
      paddingBlockEnd: theme.space['800']
    }
  });
});
export const SearchSelectWrapper = /*#__PURE__*/forwardRef(({
  children,
  collapsed,
  color,
  gradientAngle,
  isNewAppNav,
  isSticky,
  stickyTopOffset
}, ref) => {
  const isCollapsedOrSticky = collapsed || isSticky;
  const cssStyles = useMapTokenPropsToCSS({
    paddingBlock: isCollapsedOrSticky ? '200' : undefined,
    paddingBlockEnd: !isCollapsedOrSticky ? '700' : undefined
  });
  return /*#__PURE__*/_jsx(StyledSearchSelectWrapper, {
    $collapsed: collapsed,
    $color: color,
    $cssStyles: cssStyles,
    $gradientAngle: gradientAngle,
    $isNewAppNav: isNewAppNav,
    $isSticky: isSticky,
    $stickyTopOffset: stickyTopOffset,
    ref: ref,
    children: children
  });
});
export default SearchSelectWrapper;